import { COVERGO_SAAS_DEV } from "../consts.js"

export const serenity = {
	"serenity-studio.dev.asia.covergo.cloud": {
		appConfig: {
			tenantId: "serenity_dev",
			appId: "admin_portal",
		},
		envConfig: COVERGO_SAAS_DEV,
	}
}
